import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const SmallBgTopSquereIcon = ({
  width = "129",
  height = "29",
  color = "#CEDFEE",
  style,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} style={style}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 129 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M10.5888 28.4779H93.5111C103.484 28.4779 112.797 23.4836 118.328 15.169L128.473 0H9.97266L1.86331 11.9081C-2.93451 18.9375 2.08939 28.4779 10.5888 28.4779Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
